import React, {useEffect} from 'react';
import request, { METHODS } from '@/api'
import { useEffect, useState } from 'react'
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components'
import { Form, Input, Select, message, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { addNewTrackLog, getAddRecordTypeEnum } from '@/services/customerServices';
import styles from './index.module.less'
import {clueFollowLogAdd} from "@/services/callCenter";
import {trimStr} from "@/utils/data.ts";

const TextArea = Input.TextArea;

export default function AddNewFollowModal (props)  {
  const {
    editId = '',
    open = false,
    isSeat = false,
    buttonKey = '',
    onClose = () => {},
    reload = () => {},
  } = props;
  const [ form ] = Form.useForm();
  const [dictionaryData, setDictionaryData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDictionaryData();
  }, []);

  useEffect(() => {
    if (isSeat) form.setFieldValue('followType', 'trackPhone')
  }, [isSeat]);

  const fetchDictionaryData = async () => {
    try {
      const resList: any = await Promise.allSettled([
        getAddRecordTypeEnum(),
      ]);
      const map = {
        followerType: resList?.[0]?.value instanceof Array ? resList?.[0]?.value : [],
      }
      setDictionaryData(map);
    } catch (err) {
      console.log(err)
    }
  }

  const onSubmit = () => {
    form.validateFields().then((values: any) => {
        setLoading(true);
         clueFollowLogAdd({
          clueId: editId,
          ...values
        }).then(res => {
          message.success(res.message || '新增跟进记录成功');
          onClose();
          reload();
        }).finally(() => setLoading(false))
    })
  }

  return (
    <div className={styles.addNewFollowModal}>
      <SDrawerOrModal
        mode="modal"
        open={open}
        onCancel={() => onClose()}
        onOk={onSubmit}
        loading={loading}
        width={500}
        title="新增跟进"
      >
        <Form
          form={form}
          labelCol={{
            span: 8,
          }}
          name="basicInfo"
          layout="vertical"
        >
          <Form.Item
            name="followType"
            label="跟进方式"
            rules={[
              {
                required: true,
                message: '请选择跟进方式',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <Select placeholder={'请选择跟进方式'} fieldNames={{label: 'description', value: 'key' }}  options={dictionaryData?.['followerType']} />
          </Form.Item>
          <Form.Item
            name="content"
            label="跟进内容"
            rules={[
              {
                required: true,
                message: '请填写跟进内容',
              },
            ]}
            style={{
              width: '100%'
            }}
          >
            <TextArea placeholder={'请填写说明'} rows={3} maxLength={200} showCount
                      onChange={(e) => form.setFieldValue('content', trimStr(e.target.value))} />
          </Form.Item>
        </Form>
      </SDrawerOrModal>
    </div>
  )
}